module.exports = __webpack_public_path__ + "static/media/MuseoSansRounded-900.7002ff77.otf";